import React, { ReactNode } from 'react';
import type { ContainerProps } from '@mui/material';
import { Container, Box } from '@mui/material';
import CustomAppBar from './CustomAppBar';

interface LayoutProps {
  children: ReactNode;
  headerEffects?: 'playful' | 'subtle';
  containerMaxWidth?: ContainerProps['maxWidth'] | false;
  containerSx?: ContainerProps['sx'];
}

const Layout: React.FC<LayoutProps> = ({
  children,
  headerEffects = 'subtle',
  containerMaxWidth = false,
  containerSx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'background.default',
        backgroundImage:
          'linear-gradient(180deg, rgba(248, 250, 252, 0.98) 0%, rgba(241, 245, 249, 0.82) 100%)',
      }}
    >
      <CustomAppBar effects={headerEffects} />
      <Container
        maxWidth={containerMaxWidth}
        sx={{
          mt: { xs: 2.5, md: 3 },
          mb: { xs: 3, md: 4 },
          px: { xs: 2, sm: 3, md: 4 },
          flex: 1,
          ...(containerSx ?? {}),
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default Layout;
